import { AssemblyDisassemblyOrdersService } from "./../../../services/documents/AssemblyDIsassemblyOrdersService";
import { IAppEntity } from "../../entities";
import React from "react";
import { CreateAssemblyDisassemblyOrdersDto } from "../../../dtos/documents/AssemblyDisassemblyOrders/CreateAssemblyDisassemblyOrdersDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupAssemblyDisassemblyOrders } from "../../../components/Shared/NewForms/NFLookupAssemblyDIsassemblyOrders";
import {
  AssemblyDisassemblyOrdersDetail
} from "../../../components/Pages/Documents/Warehouse/AssemblyDisassemblyOrders/AssemblyDisassemblyOrdersDetail";
import AssemblyDisassemblyOrdersList
  from "../../../components/Pages/Documents/Warehouse/AssemblyDisassemblyOrders/AssemblyDisassemblyOrdersList";

export const AssemblyDIsassemblyOrders: IAppEntity = {
  entityType: "document",
  title: "Assembly/DIsassembly Orders",
  pluralTitle: "Assembly/disassembly Orders",
  apiUrl: "AssemblyDisassemblyOrders",
  apiEnum: ReferenceTypes.DocumentAssemblyDisassemblyOrder,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(AssemblyDisassemblyOrdersDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(AssemblyDisassemblyOrdersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAssemblyDisassemblyOrders, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new AssemblyDisassemblyOrdersService("AssemblyDisassemblyOrders"),
  getEmptyModel: () => {
    const model: CreateAssemblyDisassemblyOrdersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      assemblyDisassemblyOrdersGoods: [],
      quantity: 0,
      // operationType: AssemblyDIsassemblyOrdersTypeEnum.Assembly,
      
      documentDate: new Date(),
      createdDate: new Date(),
      desiredShippingDate: new Date(),
    };
    return model;
  },
};
